import { render, staticRenderFns } from "./contrast.vue?vue&type=template&id=00c0e40c&scoped=true&"
import script from "./contrast.vue?vue&type=script&lang=js&"
export * from "./contrast.vue?vue&type=script&lang=js&"
import style0 from "./contrast.vue?vue&type=style&index=0&id=00c0e40c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c0e40c",
  null
  
)

export default component.exports